import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { getPublicOrganizationSlug } from '../utils/publicOrganizationHost';

const PublicThanks = () => {
  const hasOrganizationSite = !!getPublicOrganizationSlug();

  return (
    <div className="min-h-screen bg-slate-950 px-6 flex items-center justify-center">
      <div className="w-full max-w-lg rounded-3xl bg-white p-9 text-center shadow-2xl">
        <CheckCircleIcon className="mx-auto h-16 w-16 text-emerald-500" />
        <h1 className="mt-5 text-3xl font-black text-slate-900">You’re registered.</h1>
        <p className="mt-4 leading-7 text-slate-600">
          Your registration is complete. Keep an eye on your email for event updates. If your player is assigned to a team, we’ll send an invitation to create your member login.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
          {hasOrganizationSite && (
            <Link to="/" className="rounded-full bg-slate-900 px-5 py-3 font-bold text-white">
              Back to organization
            </Link>
          )}
          <Link to="/login" className="rounded-full border border-slate-300 px-5 py-3 font-bold text-slate-700">
            Member sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PublicThanks;
